import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const MotivosDesplegablesDelete = ({
  open,
  id,
  getMotivos,
  mostrarAlerta,
  estado,
  onClose,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleClick = async () => {
    const estadoMotivoActualizado = { activa: estado };
    try {
      const response = await fetch(`${UrlApi}/SP_motivos_desplegables/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(estadoMotivoActualizado),
      });
      if (response.ok) {
        mostrarAlerta("El motivo ha sido eliminado correctamente", "success");
      } else {
        throw new Error("Error en la solicitud");
      }
      await getMotivos();
    } catch (error) {
      console.error("Error al realizar la solicitud:", error);
      mostrarAlerta(
        "Hubo un problema al eliminar el motivo. Intente nuevamente.",
        "error"
      );
    }

    logEventos(
      "activar/desactivar opcion para el desplegable motivos",
      "Motivos desplegables",
      "Mostrando/ocultando del desplegable y tabla un motivo",
      localStorage.getItem("user")
    );

    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {estado === 1
                ? "Activar motivo del desplegable"
                : "Desactivar motivo del desplegable"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Esta seguro que quiere {estado === 1 ? "activar" : "desactivar"} el
          motivo?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={handleClick}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default MotivosDesplegablesDelete;
